/**
 * @module Strings
 * @description Contains string value constant values for strings used across the Careers pages.
 */
export const STRINGS = {
  availableJobsMessage: {
    body: `<p className="mb-normal">You can also <a href="/careers/volunteer">get involved in Life.Church by volunteering.</a> We’re always making room for new leaders to join our team, so make sure to <a href="https://www.glassdoor.co.in/Jobs/Life-Church-Jobs-E367671.htm">follow us on Glassdoor</a> to get notified when we post new roles.</p>`,
    title: 'Didn’t find what you were looking for?',
  },
  general: {
    aboutInternships: 'More about Internships',
    followOnGlassdoor: 'follow us on Glassdoor',
    no: 'No',
    volunteering: 'get involved in Life.Church by volunteering.',
  },
  messages: {
    available: 'available',
    default: 'default',
    noAvailable: 'no-available',
  },
  noAvailableJobsMessage: {
    body: `<p className="mb-normal">But we’re always making room for new leaders to join our team, so make sure to <a href="https://www.glassdoor.co.in/Jobs/Life-Church-Jobs-E367671.htm">follow us on Glassdoor</a> to get notified when we post new roles! You can also <a href="/careers/volunteer">get involved in Life.Church by volunteering.</a></p>`,
    title: 'Currently, we don’t have any open roles in this area.',
  },
  roles: {
    browseAllRoles: 'Browse all of our open roles.',
    browseRoles: 'Browse open roles on our teams.',
    findFit: 'Find your fit.',
    openMany: 'Open Roles',
    openOne: 'Open Role',
  },
  teams: {
    allTeams: 'All Teams',
    backToTeams: 'Back to Teams',
    internships: 'Internships',
  },
};
